<div [ngStyle]="{ 'pointer-events': videoCargando ? 'none' : 'auto' }" class="container-animacion" (click)="onClick()">
  <div [ngClass]="videoCargando ? 'show' : 'hide'" class="lds-facebook">
    <div></div>
    <div></div>
    <div></div>
  </div>
  <svg [ngClass]="videoCargando ? 'hide' : 'show'" class="playBut" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:a="http://ns.adobe.com/AdobeSVGViewerExtensions/3.0/" x="0px" y="0px" width="213.7px" height="213.7px" viewBox="0 0 233.7 233.7" enable-background="new 0 0 213.7 213.7" xml:space="preserve">
    <defs>
      <radialGradient id="gradienteBlanco" cx="50%" cy="50%" r="50%" fx="50%" fy="50%">
        <stop offset="0%" style="stop-color: white; stop-opacity: 0.4" />
        <stop offset="100%" style="stop-color: white; stop-opacity: 0" />
      </radialGradient>
    </defs>

    <!-- Círculo con degradado -->
    <circle class="circle" id="XMLID_17_" fill="url(#gradienteBlanco)" stroke-width="15" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" cx="116.8" cy="116.8" r="103.3" />

    <!-- Polígono (triángulo) -->
    <polygon class="triangle" id="XMLID_18_" fill="none" stroke-width="15" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" points="83.5,72.5 158.5,115.8 83.5,159.1" />
  </svg>
</div>
